import { tokenTimeChecker } from "utils/helpers/tokenTimeChecker";
import { refreshSession, getLastRefreshFailure } from "core/session";
import { fingerPrintSaver } from "utils/helpers";
import { actionTypes } from "./ducks/auth/authTypes";
import authActions from "./ducks/auth/authActions";
import { tokenLogger } from "./tokenLogger";

export const tokenChecker = (store: any) => (next: any) => (action: any) => {
  // DEV-autologin: полностью пропускаем проверку/refresh токена. Иначе на другом
  // устройстве (телефоне) одноразовый refresh-токен, уже использованный маком,
  // ловит 403 и уводит страницу в бесконечную перезагрузку. Доверяем вшитому
  // accessToken (см. core/devSeed).
  if (
    process.env.REACT_APP_ENV_MODE === "development" &&
    process.env.REACT_APP_DEV_AUTOLOGIN !== "0" &&
    !(window as any).__DEV_NO_AUTOLOGIN__ &&
    process.env.REACT_APP_DEV_ACCESS_TOKEN
  ) {
    return next(action);
  }
  tokenLogger.init()
  if (!window.localStorage.fingerPrint) fingerPrintSaver();
  if (!store.getState().authReducer.isAuth) return next(action);
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  if (tokenTimeChecker(window.localStorage.tokenTime)) {
    // Токен свежий (только что получен при входе/регистрации) — «первый refresh»
    // не нужен. Иначе firstRefresh оставался true до перезагрузки страницы, и как
    // только токен устаревал, все thunk'и вставали в очередь навсегда (на экране
    // загрузки фото «Продолжить» переставала работать).
    if (store.getState().authReducer.firstRefresh) {
      next(authActions.firstRefresh(false));
    }
    return next(action);
  } else {
    if (typeof action === "function") {
        console.log('tokenChecker: thunk action detected, isRefreshing:', store.getState().authReducer.isRefreshing);
        console.log('tokenChecker: firstRefresh:', store.getState().authReducer.firstRefresh);
        console.log('tokenChecker: offline:', store.getState().authReducer.offline);
      }

    if (
      window.localStorage.refreshToken !== undefined &&
      window.localStorage.refreshToken !== "" &&
      window.localStorage.refreshToken !== "undefined" &&
      action.type === actionTypes.REFRESH &&
      !store.getState().authReducer.isRefreshing
    ) {
      tokenLogger.setStart(action.payload, new Date().toLocaleString(), window.localStorage.refreshToken, window.localStorage.fingerPrint, window.localStorage.idProfile)
      store.dispatch(authActions.setRefreshing(true));
      // Тот же single-flight refresh, что и у axios-interceptor'а (core/session):
      // раньше middleware и interceptor обновляли токен НЕЗАВИСИМО и могли
      // отправить один одноразовый refresh-токен дважды → 403 → разлогин.
      refreshSession("middleware").then((token) => {
        store.dispatch(authActions.setRefreshing(false));
        store.dispatch(authActions.firstRefresh(false));
        if (token) {
          store.dispatch(authActions.setOffline(false));
          tokenLogger.setSuccess(window.localStorage.refreshToken);
          next(action);
        } else if (getLastRefreshFailure() === "network") {
          // сеть — не разлогин; очередь подождёт следующей попытки
          store.dispatch(authActions.setOffline(true));
          tokenLogger.setFail("network");
          window.setTimeout(() => store.dispatch(authActions.refresh("retry after network error")), 3000);
        } else {
          // невалидный refresh — refreshSession уже разлогинил
          tokenLogger.setFail("invalid");
        }
      });
    } else {
      if (typeof action === "function") {
        console.log('tokenChecker: Queuing thunk action...');

        // Очередь не должна висеть без обновления токена: если refresh никто
        // не запустил — запускаем сами.
        const st = store.getState().authReducer;
        if (!st.isRefreshing && window.localStorage.refreshToken) {
          store.dispatch(authActions.refresh("tokenChecker queued thunk"));
        }

        // Возвращаем Promise с результатом thunk'а — вызывающий код (например,
        // «Продолжить» на загрузке фото ждёт result.then) получит ответ, а не undefined.
        return new Promise((resolve) => {
          setTimeout(function check() {
              const state = store.getState().authReducer;
              console.log('tokenChecker: Checking if ready, isRefreshing:', state.isRefreshing, 'firstRefresh:', state.firstRefresh, 'offline:', state.offline);
              if (!state.isRefreshing && !state.firstRefresh && !state.offline) {
                console.log('tokenChecker: Executing thunk action');
                resolve(next(action));
              } else {
                setTimeout(check, 100);
              }
          }, 100);
        });
      } else {
        return next(action);
      }
    }
  }
};
